// ===== rules/rule-0060-polytrauma.ts ======================================
import { BaseRule } from '../rule-base';
import { AdjustedLine, ModifierContext } from '../modifier-models';

/**
 * 0060 – musculoskeletal *poly-trauma*: every procedure is paid at 100 %
 * (i.e. 0005 reductions must be undone).
 */
export class RulePolyTrauma extends BaseRule {
    name = '0060 poly-trauma (cancel 0005)';

    run(line: AdjustedLine, ctx: ModifierContext, autoApply: boolean): void {
        // Since we need to check if 0060 exists in any line and if 0005 was applied,
        // we'll need to rely on the apply method for this rule
        if (autoApply) {
            line.trace.push('0060: Requires full context for calculation');
        } else {
            line.suggestions = line.suggestions || [];
            line.suggestions.push({
                ruleCode: '0060',
                message: 'Poly-trauma calculation requires full context',
                kind: 'overwrite'
            });
        }
    }

    apply(lines: AdjustedLine[], ctx: ModifierContext): AdjustedLine[] {
        if (!lines.some(l => l.code === '0060')) return lines;

        lines
            .filter(l => !l.isModifier && !l.isConsult && l.trace.some(t => t.startsWith('0005')))
            .forEach(l => {
                l.adjustedUnits = l.units;     // restore original
                l.trace.push('0060 removed 0005 reduction');
            });

        return lines;
    }
}
